import { useState, useRef, useEffect,useCallback } from "react";
import { ORG_IMPORT_MASTER_UPLOAD,ORG_IMPORT_MASTER_TEMPLATES, ORG_GENERATE_PRESIGNED_URL } from '../../../../../ApiServices/BaseURL';
import { getData, postData } from "../../../../../ApiServices/ApiService";
import * as XLSX from 'xlsx';
import { logFrontendException } from "../../../../../Utils/Exception";
import { useTheme } from "../../../../../GlobalContext/GlobalContext";

const UploadClientsListFileController = (importMasterList,onRefresh,fileInputRef) => {
    const [tasks, setTasks] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5; // Adjust as needed
    const intervalRef = useRef(null);
    const { setIsLoginPopup } = useTheme();
  const pageName = "UploadClientsListFileController";
  const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;

    const totalPages = Math.ceil(importMasterList?.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentTasks = importMasterList?.slice(indexOfFirstItem, indexOfLastItem);

    // ✅ Memoized check function
    const checkUploadStatus = useCallback(() => {
        console.log('Checking status...',importMasterList);
        const hasPendingStatus = importMasterList.some(item => item?.upload_status_name === "Pending");
        console.log('Has Pending Status:', hasPendingStatus);
        if (hasPendingStatus) {
            console.log('Calling onRefresh...');
            onRefresh();
        }else {
        if (intervalRef.current) {
            console.log('No pending items. Clearing interval...');
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    }
    }, [importMasterList]);


    // ✅ 2-minute interval setup
    useEffect(() => {
        intervalRef.current = setInterval(() => {
            checkUploadStatus();
        }, 60000); // 2 minutes

        return () => {
            console.log('Clearing interval...');
            clearInterval(intervalRef.current);
        };
    }, [checkUploadStatus]);
    

    const handlePageChange = (pageNumber) => {
        if (pageNumber > 0 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    const [importMasterError, setImportMasterError] = useState('');
        const [importMasterLoading, setImportMasterLoading] = useState(false);
        const [importMasterSuccess, setImportMasterSuccess] = useState('');
    const handleFileChange1 = (event) => {
        setImportMasterError('')
        const file = event.target.files[0];
    
        if (file) {
            const reader = new FileReader();
    
            reader.onload = (e) => {
                const text = e.target.result;
                console.log("Raw CSV Text:", text);
    
                const lines = text.split("\n").map(line => line.trim()).filter(line => line !== "");
    
                if (lines.length < 2) {
                    setImportMasterError("Invalid CSV file: Not enough data");
                    return;
                }
    
                let headers = lines[0].split(",").map(header => header.trim());
                console.log("Detected Headers:", headers);
    
                let records = [];
    
                // Read the data rows
                lines.slice(1).forEach((line, index) => {
                    let values = line.split(",").map(value => value.trim());
                    let record = {};
    
                    headers.forEach((header, i) => {
                        record[header] = values[i] || null;
                    });
    
                    records.push(record);
                });
    
                console.log("Extracted Records:", records); 
    
                let payload = {};
    
                // **Determine which type of data this CSV file contains**
                if (headers.includes("client_file_id") && headers.includes("opening_amount")) {
                    payload["Opening_Balance"] = records;
                    console.log(" Detected: Opening Balance Data");
                } else if (headers.includes("client_file_id") && headers.includes("service_name")) {
                    payload["Bulk_Tasks"] = records;
                    console.log(" Detected: Bulk Tasks Data");
                } else if (headers.includes("client_name")) {
                    payload["Bulk_Client_Upload"] = records;
                    console.log(" Detected: Bulk Client Upload Data");
                } else {
                    setImportMasterError(" Unrecognized CSV Format: No matching headers found.");
                    return;
                }
    
                console.log(" Final Extracted Payload:", JSON.stringify(payload, null, 4));
                handleImportMasterUpload(payload);
            };
    
            reader.readAsText(file);
        }
    };

    const handleFileChangeCSV = (event) => {
        setImportMasterError('');
        const file = event.target.files[0];
    
        if (file) {
            const reader = new FileReader();
    
            reader.onload = (e) => {
                const text = e.target.result;
                console.log("Raw CSV Text:", text);
    
                const lines = text.split("\n").map(line => line.trim()).filter(line => line !== "");
                console.log("Raw CSV lines:", lines);
    
                if ((lines.length <= 1)) {
                    setImportMasterError("Invalid CSV file: No data found");
                    return;
                }
    
                let originalHeaders = lines[0].split(",").map(header => header.trim());
                console.log("Detected Headers from Uploaded File:", originalHeaders);
    
                let records = [];
                let errorMessages = [];
    
                // **Detect which type of file is uploaded**
                let detectedSheet = null;
                if (originalHeaders.includes("File Number") && originalHeaders.includes("Opening balance")) {
                    detectedSheet = "Opening_Balance";
                } else if (originalHeaders.includes("File Number") && originalHeaders.includes("Services")) {
                    detectedSheet = "Bulk_Tasks";
                } else if (originalHeaders.includes("Client Name")) {
                    detectedSheet = "Bulk_Client_Upload";
                }
    
                if (!detectedSheet) {
                    setImportMasterError("Unrecognized CSV Format: No matching headers found.");
                    return;
                }
    
                console.log(`Detected Sheet Type: ${detectedSheet}`);
    
                // **Header Mapping for Backend Payload**
                const headerMappings = {
                    "Opening_Balance": {
                        "File Number": "client_file_id",
                        "Opening balance": "opening_amount"
                    },
                    "Bulk_Tasks": {
                        "File Number": "client_file_id",
                        "Services": "service_name",
                        "Service Category": "service_sub_name",
                        "Financial Year": "financial_year",
                        "Period": "financial_period",
                        "Start Date": "task_start_date",
                        "Due Date": "task_due_date",
                        "Estimated Invoice Amount": "invoice_amt_estimated",
                        "Agreed Invoice Amount": "invoice_amt_agreed",
                        "Description": "task_description"
                    },
                    "Bulk_Client_Upload": {
                        "Client Name": "client_name",
                        "Client Type": "client_type_name",
                        "Identification Type": "client_identity_doc_id",
                        "Identification Number": "client_identity_doc_id_number",
                        "Date of Enrollment": "client_enrolled_on",
                        "Group Name": "group_name",
                        "Address": "client_address",
                        "City": "client_city",
                        "State": "client_state",
                        "Pin Code": "client_pin",
                        "Mobile Number": "client_mobile_no",
                        "GSTIN": "client_gstin",
                        "Aadhar Number": "client_aadhar_no",
                        "PAN": "client_pan_no",
                        "Client Assigned User": "emp_id_incharge_name",
                        "NRI": "is_india_client",  // Convert Yes/No to 1/0
                        "E-mail Id": "client_email",
                        "Primary Contact Name": "contact_name",
                        "Primary Contact Phone Number": "contact_phone_no",
                        "Primary Contact E-mail id": "contact_email",
                        "Primary Contact Role": "contact_role"
                    }
                };
    
                const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
                const emp_id_auth = storedUserInfo?.emp_id;
                let mappedHeaders = headerMappings[detectedSheet];
    
                lines.slice(1).forEach((line, rowIndex) => {
                    let values = line.split(",").map(value => value.trim());
                    let record = {};
    
                    originalHeaders.forEach((header, i) => {
                        let backendHeader = mappedHeaders[header] || header; // Map headers or keep original
    
                        let value = values[i] || null;
    
                        // Convert "Yes" -> 1, "No" -> 0 for `is_india_client`
                        if (backendHeader === "is_india_client") {
                            value = value?.toLowerCase() === "yes" ? 1 : 0;
                        }
    
                        record[backendHeader] = value;
                    });
    
                    // **Validation Check**
                    if (detectedSheet === "Opening_Balance") {
                        let requiredFields = ["client_file_id", "opening_amount"];
    
                        let missingFields = requiredFields.filter(field =>
                            !record[field] || record[field].toString().trim() === "" || record[field] === undefined
                        );
    
                        if (missingFields.length > 0) {
                            errorMessages = [`Missing required fields: ${missingFields.join(", ")}`];
                        }
                    }
                    
    
                    if (detectedSheet === "Bulk_Client_Upload") {
                        let requiredFields = [
                            "client_name", "client_type_name", "client_identity_doc_id", "client_identity_doc_id_number",
                            "client_mobile_no", "client_address", "client_city", "client_state", "client_gstin",
                            "client_aadhar_no", "client_email", "emp_id_incharge_name", "is_india_client"
                        ];
                    
                        let missingFields = requiredFields.filter(field => 
                            record[field] === null || record[field] === "" || record[field] === undefined
                        );
                    
                        if (missingFields.length > 0) {
                            errorMessages = [`Missing required fields: ${missingFields.join(", ")}`]; // Reset & set single message
                        }
                    }

                    if (detectedSheet === "Bulk_Tasks") {
                        let requiredFields = [
                            "client_file_id", "service_name", "service_sub_name", "financial_year",
                            "financial_period", "task_start_date", "task_due_date",
                        ];
                    
                        let missingFields = requiredFields.filter(field => 
                            record[field] === null || record[field] === "" || record[field] === undefined
                        );
                    
                        if (missingFields.length > 0) {
                            errorMessages = [`Missing Rrquired fields: ${missingFields.join(", ")}`]; // Reset & set single message
                        }
                    }
                    
                    
    
                    records.push(record);
                });
    
                if (errorMessages.length > 0) {
                    setImportMasterError(errorMessages);
                    return;
                }
    
                // ** Final Payload Structure**
                let payload = {
                    emp_id_auth,
                    [detectedSheet]: records
                };
    
                console.log("Final Payload for Backend:", JSON.stringify(payload, null, 4));
                handleImportMasterUpload(payload);
                event.target.value = null;
            };
    
            reader.readAsText(file);
        }
    };
    const excelDateToJSDate = (serial) => {
        const excelEpoch = new Date(Date.UTC(1899, 11, 30));
        return new Date(excelEpoch.getTime() + serial * 86400000);
    };

    const handleFileChange = (event) => {
        setImportMasterError('');
        const file = event.target.files[0];
    
        if (!file) return;

        const fileName = file.name;
    
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
    
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];
    
            // Convert to JSON array
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "" }); // defval keeps empty cells
    
            if (!jsonData.length) {
                setImportMasterError("Invalid Excel file: No data found");
                event.target.value = null
                return;
            }
            if (jsonData.length > 500) {
                setImportMasterError("Upload limit exceeded. Maximum 500 records allowed.");
                event.target.value = null
                return;
            }
            const originalHeaders = Object.keys(jsonData[0]);
            // console.log("Detected Headers from Excel:", originalHeaders);
    
            let detectedSheet = null;
            if (originalHeaders.includes("File Number") && originalHeaders.includes("Opening balance")) {
                detectedSheet = "Opening_Balance";
            } else if (originalHeaders.includes("File Number") && originalHeaders.includes("Services")) {
                detectedSheet = "Bulk_Tasks";
            } else if (originalHeaders.includes("Client Name")) {
                detectedSheet = "Bulk_Client_Upload";
            }
    
            if (!detectedSheet) {
                setImportMasterError("Unrecognized Excel Format: No matching headers found.");
                event.target.value = null
                return;
            }
    
            const headerMappings = {
                "Opening_Balance": {
                    "File Number": "client_file_id",
                    "Opening balance": "opening_amount"
                },
                "Bulk_Tasks": {
                    "File Number": "client_file_id",
                    "Services": "service_name",
                    "Service Category": "service_sub_name",
                    "Financial Year": "financial_year",
                    "Period": "financial_period",
                    "Start Date": "task_start_date",
                    "Due Date": "task_due_date",
                    "Estimated Invoice Amount": "invoice_amt_estimated",
                    "Agreed Invoice Amount": "invoice_amt_agreed",
                    "Description": "task_description"
                },
                "Bulk_Client_Upload": {
                    "Client Name": "client_name",
                    "File Number": "client_file_id",
                    "Client Type": "client_type_name",
                    "Identification Type": "client_identity_doc_id",
                    "Identification Number": "client_identity_doc_id_number",
                    "Date of Enrollment": "client_enrolled_on",
                    "Group Name": "group_name",
                    "Address": "client_address",
                    "City": "client_city",
                    "State": "client_state",
                    "Pin Code": "client_pin",
                    "Mobile Number": "client_mobile_no",
                    "GSTIN": "client_gstin",
                    "Aadhar Number": "client_aadhar_no",
                    "PAN": "client_pan_no",
                    "Client Assigned User": "emp_id_incharge_name",
                    "NRI": "is_india_client",  // Convert Yes/No to 1/0
                    "E-mail Id": "client_email",
                    "Primary Contact Name": "contact_name",
                    "Primary Contact Phone Number": "contact_phone_no",
                    "Primary Contact E-mail id": "contact_email",
                    "Primary Contact Role": "contact_role"
                }
            };
    
            const mappedHeaders = headerMappings[detectedSheet];
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const emp_id_auth = storedUserInfo?.emp_id;
    
            let errorMessages = [];
            let records = [];
    
            jsonData.forEach((row, index) => {
                let record = {};
    
                Object.keys(mappedHeaders)?.forEach((header) => {
                    let backendKey = mappedHeaders[header];
                    let value = row[header] ?? null;
    
                    if (backendKey === "is_india_client") {
                        value = value?.toString().toLowerCase() === "yes" ? 1 : 0;
                    }

                    // if (backendKey === "client_enrolled_on" || backendKey === "task_start_date" || backendKey === "task_due_date") {
                    //     // Detect if value is number (Excel date serial), and convert
                    //     if (typeof value === "number") {
                    //         const jsDate = excelDateToJSDate(value);
                    //         value = jsDate?.toISOString()?.split("T")[0]; // 'YYYY-MM-DD'
                    //     } else if (typeof value === "string" && value?.includes("/")) {
                    //         value = new Date(value)?.toISOString()?.split("T")[0];
                    //     }
                    // }

                    if (backendKey === "client_enrolled_on" || backendKey === "task_start_date" || backendKey === "task_due_date") {
                        if (typeof value === "number") {
                            const jsDate = excelDateToJSDate(value);
                            const year = jsDate.getFullYear();
                            const month = String(jsDate.getMonth() + 1).padStart(2, '0');
                            const day = String(jsDate.getDate()).padStart(2, '0');
                            value = `${year}-${month}-${day}`;  // LOCAL DATE
                        }
                        else if (typeof value === "string" && (value.includes("/") || value.includes("-"))) {
                            const separator = value.includes("/") ? "/" : "-";
                            const parts = value.split(separator); // [DD, MM, YYYY]
                            if (parts.length === 3) {
                                const [day, month, year] = parts;
                                const jsDate = new Date(`${year}-${month}-${day}`);
                                if (!isNaN(jsDate.getTime())) {
                                    const y = jsDate.getFullYear();
                                    const m = String(jsDate.getMonth() + 1).padStart(2, '0');
                                    const d = String(jsDate.getDate()).padStart(2, '0');
                                    value = `${y}-${m}-${d}`;  // LOCAL DATE
                                } else {
                                    console.warn("Invalid date format:", value);
                                    value = "";
                                }
                            }
                        }
                    }
                    
                    
    
                    record[backendKey] = value;
                });
    
                // Validate required fields
                let requiredFields = [];
                if (detectedSheet === "Opening_Balance") {
                    requiredFields = ["client_file_id", "opening_amount"];
                } else if (detectedSheet === "Bulk_Client_Upload") {
                    requiredFields = [
                        "client_name", "client_type_name", "client_identity_doc_id", "client_identity_doc_id_number",
                        "client_mobile_no", "client_address", "client_city", "client_state", 
                        "client_aadhar_no", "client_email", "emp_id_incharge_name", "is_india_client"
                    ];
                } else if (detectedSheet === "Bulk_Tasks") {
                    requiredFields = [
                        "client_file_id", "service_name", "service_sub_name", "financial_year",
                        "financial_period", "task_start_date", "task_due_date"
                    ];
                }
    
                const missingFields = requiredFields.filter(
                    (field) => record[field] === null || record[field] === "" || record[field] === undefined
                );
    
                if (missingFields.length > 0) {
                    errorMessages.push(`Row ${index + 2}: Missing fields - ${missingFields.join(", ")}`);
                }
    
                records.push(record);
            });
    
            if (errorMessages.length > 0) {
                setImportMasterError(errorMessages);
                event.target.value = null
                return;
            }
    
            let payload = {
                emp_id_auth,
                [detectedSheet]: records
            };
    
            // console.log("Final Payload for Backend:", JSON.stringify(payload, null, 4));
            handleImportMasterUpload(payload,detectedSheet,fileName,file);
            event.target.value = null;
        };
    
        reader.readAsArrayBuffer(file); // Important: For Excel, use ArrayBuffer
    };
    
    

        const handleImportMasterUpload = async (payload,detectedSheet,fileName,file) => {
            // console.log("apply values", groupName?.value, clientType?.value, cleintAssignedUser?.value, nri?.value, address, location, state?.value, pinCode,);
            // return
            // console.log("location:", typeof location, location);
            try {
    
                // setError('');
                setImportMasterError('')
                setImportMasterSuccess('');
    
                // if(!groupName && !clientType && !cleintAssignedUser && !nri && !address && !selectedLocation && !location.trim()  && !state && !pinCode && !base64File){
                //     setBulkUpdateOfClientInformationError('Please select at least one feild');
                //     return
                // }
                setImportMasterLoading(true);
    
                const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
                const emp_id_auth = storedUserInfo?.emp_id;
                // const payLoad = {
                //     "action": "bulk_update",
                //     emp_id_auth: storedUserInfo?.emp_id,
                //     doc_name:uploadedFileName?.split('.')[0],
                //     doc_base_64: base64File,
                //     doc_name_with_ext: uploadedFileName,
                //     // client_name: nameOfClient,
                //     group_id: groupName?.value || 0,
                //     emp_id_incharge:cleintAssignedUser?.value ||0,
                //     client_type_id: clientType?.value ||0,
                //     is_india_client: nri?.value ||0,
                //     client_address:address ||'',
                //     client_city:location ||'',
                //     client_state: state?.label ||'',
                //     client_pin: pinCode ||'',
                //     doc_is_internal: 1,
                //     client_id: selectedClients
                // }
    
                // console.log('handle Bulk Update Of CLient Information payload', payload);
                // return
                // Make the API call

                const presignResult = await getS3PresignedUploadUrl(fileName)

                const { url, fields, object_key } = presignResult;
                
                const formData = new FormData();
                Object.entries(fields).forEach(([key, value]) => {
                formData.append(key, value);
                });
                formData.append("file", file);

                const uploadResponse = await fetch(url, {
                method: "POST",
                body: formData
                });

                if (uploadResponse.status !== 204) {
                throw new Error("S3 file upload failed.");
                }

                const payLoad = {
                    emp_id_auth: emp_id_auth,
                    [detectedSheet]: object_key
                }

                console.log("payLoad",payLoad)

                const response = await postData(ORG_IMPORT_MASTER_UPLOAD, payLoad);
                const responseData = await response.json();
                //console.log('response Data', responseData);
    
                // Check for success (200) and internal status code
                if (response?.status === 200) {
                    if (responseData?.statusCode === 200) {
                        if (responseData?.message.toLowerCase() === 'success') {
                            setImportMasterError('')
                            setImportMasterSuccess(responseData?.info);
                            onRefresh();
                            // clearFeilds();
                            setTimeout(() => {
                                // handleClose();
                                // handleCancleClick();
                                // onValueChange();
                                setImportMasterSuccess('');
                            }, 3000);
                        } else {
                            setImportMasterError(responseData?.info || 'Failed to upload xlsx file.');
                            // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
                            logFrontendException(storedUserId, pageName, "handleImportMasterUpload", responseData || '');
                        }
                    } else {
                        setImportMasterError(responseData?.info || 'Failed to upload xlsx file.Please try again.');
                        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
                        logFrontendException(storedUserId, pageName, "handleImportMasterUpload", responseData || '');
                    }
                }
                // Token-related errors: 400, 401, 403
                else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                    setImportMasterError('Unauthorized access. Your session may have expired. Please log in again.');
                    // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
                    logFrontendException(storedUserId, pageName, "handleImportMasterUpload", response || '');
                    setIsLoginPopup(true)
                }
                else {
                    setImportMasterError('Failed to upload xlsx fil. Please try again later.');
                    // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
                    logFrontendException(storedUserId, pageName, "handleImportMasterUpload", response || '');
                }
            } catch (error) {
                console.log("errror",error);
                setImportMasterError(`Failed to upload xlsx file. Please check your network connection and try again.`);
                // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
                logFrontendException(storedUserId, pageName, "handleImportMasterUpload-catch", error || '');
                
            } finally {
                setImportMasterLoading(false);
                onRefresh();
                if (fileInputRef.current) {
                    fileInputRef.current.value = null;
                }
            }
    
        };

        // const [importMasterTemplateLink, setImportMasterTemplateLink] = useState([]);
        const [importMasterTemplateError, setImportMasterTemplateError] = useState('');
        const [importMasterTemplatesLoading, setImportMasterTemplatesLoading] = useState(false)
        const handleImportMasterTemplates = async (option) => {
            try {
                setImportMasterTemplatesLoading(true);
                setImportMasterTemplateError('');
                const payloadMapping = {
                    "Bulk Client Upload": "client_import",
                    "Bulk Task Upload": "task_import",
                    "Opening Balance": "opening_balance_import",
                };
    
                const payload = {
                    file: payloadMapping[option],
                };
    
                console.log('handle Bulk Update Of CLient Information payload', payload);
                // return
                // Make the API call
                const response = await postData(ORG_IMPORT_MASTER_TEMPLATES, payload);
                const responseData = await response.json();
                //console.log('response Data', responseData);
    
                // Check for success (200) and internal status code
                if (response?.status === 200) {
                    if (responseData?.statusCode === 200) {
                        if (responseData?.message.toLowerCase() === 'success') {
                            setImportMasterTemplateError('')
                            const downloadUrl = responseData.dataJ[0]?.download_url;
                            downloadFile(downloadUrl);
                        } else {
                            setImportMasterTemplateError(responseData?.info || 'Failed to download xlsx file. Please try again.');
                            logFrontendException(storedUserId, pageName, "handleImportMasterUpload", responseData || '');
                        }
                    } else {
                        setImportMasterTemplateError(responseData?.info || 'Failed to download xlsx file. Status code error.');
                        logFrontendException(storedUserId, pageName, "handleImportMasterUpload", responseData || response || '');
                    }
                }
                // Token-related errors: 400, 401, 403
                else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                    setImportMasterTemplateError('Unauthorized access. Your session may have expired. Please log in again.');
                    logFrontendException(storedUserId, pageName, "handleImportMasterUpload", response || '');
               
                }
                else {
                    setImportMasterTemplateError('Unexpected error occurred. Please try again later.');
                    logFrontendException(storedUserId, pageName, "handleImportMasterUpload", response || '');
                }
            } catch (error) {
                setImportMasterTemplateError(`Failed to download xlsx file. Please check your network connection and try again.`);
                logFrontendException(storedUserId, pageName, "handleImportMasterUpload-catch", error || '');
                
            } finally {
                setImportMasterTemplatesLoading(false);
            }
        };

        const downloadFile = (url) => {
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Schedule Report.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        };

        
    const maxVisiblePages = 3;
    const getVisiblePages = () => {
        const startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
        const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
    
        // Adjust startPage if we're near the end
        const adjustedStartPage = Math.max(1, endPage - maxVisiblePages + 1);
        return Array.from({ length: endPage - adjustedStartPage + 1 }, (_, index) => adjustedStartPage + index);
    };

    const visiblePages = getVisiblePages();

    const getS3PresignedUploadUrl = async (fileName) => {
            try {
    
                const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
                // Make the API call

                const payLoad = {
                    emp_id_auth: storedUserInfo?.emp_id,
                    file_name: fileName,
                }

                const response = await postData(ORG_GENERATE_PRESIGNED_URL, payLoad);
                const responseData = await response.json();

                console.log("responseData",responseData)
    
                // Check for success (200) and internal status code
                if (response?.status === 200) {
                    if (responseData?.status_code === 200) {
                        if (responseData?.message.toLowerCase() === 'success') {
                            return responseData.dataJ[0];
                        } else {
                            setImportMasterError(responseData?.info || 'Failed to upload xlsx file.');
                            logFrontendException(storedUserId, pageName, "getS3PresignedUploadUrl", responseData || '');
                        }
                    } else {
                        setImportMasterError(responseData?.info || 'Failed to upload xlsx file.Please try again.');
                        logFrontendException(storedUserId, pageName, "getS3PresignedUploadUrl", responseData || '');
                    }
                }
                // Token-related errors: 400, 401, 403
                else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                    setImportMasterError('Unauthorized access. Your session may have expired. Please log in again.');                    logFrontendException(storedUserId, pageName, "handleImportMasterUpload", response || '');
                    setIsLoginPopup(true)
                }
                else {
                    setImportMasterError('Failed to upload xlsx fil. Please try again later.');
                    logFrontendException(storedUserId, pageName, "getS3PresignedUploadUrl", response || '');
                }
            } catch (error) {
                setImportMasterError(`Failed to upload xlsx file. Please check your network connection and try again.`);
                logFrontendException(storedUserId, pageName, "getS3PresignedUploadUrl-catch", error || '');
                
            } finally {
                if (fileInputRef.current) {
                    fileInputRef.current.value = null;
                }
            }
    
        };
    
    return {
        tasks: currentTasks,
        currentPage,
        totalPages, visiblePages,
        handlePageChange,
        handleFileChange,
        importMasterSuccess,
        importMasterLoading,
        importMasterError,
        downloadFile,
        handleImportMasterTemplates,
        importMasterTemplatesLoading,
        importMasterTemplateError
    };
};

export default UploadClientsListFileController;
